import { EnumReturnTypeValueProps } from 'models/Ticket';
import { IUser } from 'models/User';
import { MessagesError } from 'pages/OpenProtocol/interface';

export const SetMessageErrorNewProtocol = (setErrorMessage: Function, message: string) => {
  if (message?.includes('CNPJ')) {
    setErrorMessage(MessagesError.CNPJ);
  } else if (message?.includes('CPF')) {
    setErrorMessage(MessagesError.CPF);
  } else {
    setErrorMessage(MessagesError.DEFAULT);
  }
};

export const lockedProduct = (
  locked: boolean,
  protocolCategory: string,
  returnType: string,
  user?: IUser,
  cancelationDate?: Date | string
) => {

  let isLockedProduct = false;

  if (locked || cancelationDate) {
    isLockedProduct = true;
  }

  const isLogisticOrCommercialUser =
    user?.profileType?.includes('CC_LOGISTIC_SERVICE') ||
    user?.profileType?.includes('INTERNAL_COMMERCIAL') ||
    returnType.toUpperCase() === EnumReturnTypeValueProps.ON_DELIVERY;

  if (isLogisticOrCommercialUser && !cancelationDate) {
    isLockedProduct = false;
  }

  return isLockedProduct;
};